import { render, staticRenderFns } from "./DBSCheckDetails.vue?vue&type=template&id=4446beef&scoped=true&"
import script from "./DBSCheckDetails.vue?vue&type=script&lang=js&"
export * from "./DBSCheckDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4446beef",
  null
  
)

export default component.exports